module.exports = __webpack_public_path__ + "img/1531021035.6a4be132.jpg";